var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#ED1A3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.976 222V204.864H101.216C111.584 204.864 117.344 197.808 117.344 189.456C117.344 181.032 111.656 173.976 101.216 173.976H78.752V222H88.976ZM99.776 195.864H88.976V182.976H99.776C103.808 182.976 106.904 185.424 106.904 189.456C106.904 193.416 103.808 195.864 99.776 195.864Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 222C157.736 222 168.176 212.496 168.176 197.952C168.176 183.552 157.736 173.976 142.688 173.976H123.752V222H142.76ZM142.688 213H133.976V182.976H142.76C152.552 182.976 157.736 189.528 157.736 197.952C157.736 206.16 152.192 213 142.688 213Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.656 222V202.056H208.912V193.056H185.656V182.976H209.416V173.976H175.432V222H185.656Z",
    fill: "#F9F9F9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.3c2c63b0c7a6c545b0bf07a8b6255053.svg";